import { render } from "./AnnualCategoryDetail.vue?vue&type=template&id=92cd551a&scoped=true"
import script from "./AnnualCategoryDetail.vue?vue&type=script&lang=js"
export * from "./AnnualCategoryDetail.vue?vue&type=script&lang=js"

import "./AnnualCategoryDetail.vue?vue&type=style&index=0&id=92cd551a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92cd551a"]])

export default __exports__